import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaCollapse from './VaCollapse.vue'

export const VaCollapse = withConfigTransport(_VaCollapse)
